module.exports = __webpack_public_path__ + "static/media/  (29).f22f1550.jpg";